import { useEffect, useState } from "react";
import { initialOf } from "../format.ts";

type Props = {
  name: string | null;
  picture: string | null;
  size: "small" | "large";
  /** 読み上げる名前。装飾として扱うなら省く */
  label?: string;
};

/** アイコン画像。無い、または読み込めないときは名前の頭文字を出す */
export function Avatar({ name, picture, size, label }: Props) {
  const [failed, setFailed] = useState(false);
  // biome-ignore lint/correctness/useExhaustiveDependencies: 画像が変わったら読み込みをやり直す
  useEffect(() => setFailed(false), [picture]);

  const className = `avatar avatar--${size}`;
  const a11y = label === undefined ? { "aria-hidden": true } : { role: "img", "aria-label": label };
  if (picture !== null && !failed) {
    return (
      <span className={className} {...a11y}>
        <img src={picture} alt="" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
      </span>
    );
  }
  return (
    <span className={className} {...a11y}>
      {initialOf(name)}
    </span>
  );
}
